<template>
  <c-box
    v-if="disabled"
    d="inline-block"
    fontSize="lg"
    pl="3xl"
    pr="3xl"
    pt="sm"
    pb="sm"
    borderRadius="full"
    :background="currentStep === step ? 'brand.purple' : 'transparent'"
    :color="currentStep === step ? 'white' : 'black'"
    text-overflow="ellipsis"
    white-space="nowrap"
    overflow="hidden"
    opacity="0.6"
  >
    <slot />
  </c-box>
  <router-link v-else :to="{ path, query: { step } }">
    <c-box
      d="inline-block"
      fontSize="lg"
      pl="3xl"
      pr="3xl"
      pt="sm"
      pb="sm"
      borderRadius="full"
      :background="currentStep === step ? 'brand.purple' : 'transparent'"
      :color="getColor"
      text-overflow="ellipsis"
      white-space="nowrap"
      overflow="hidden"
    >
      <slot />
    </c-box>
  </router-link>
</template>

<script lang="ts">
import { CBox } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "WizardTab",
  components: {
    CBox,
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errored: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getColor(): string {
      if (this.errored) {
        return this.currentStep === this.step ? "brand.redLight" : "brand.red";
      } else if (this.currentStep === this.step) {
        return "white";
      }
      return "black";
    },
  },
});
</script>
